import _ from 'lodash';
import UtilService from '../services/util';
import OpenNotification from '../components/common/CommonButton/OpenNotification';
import {
  SEARCH_DIAMOND_LIST,
  SEARCH_LIST,
  CREATE_SAVED_SEARCH,
  CREATE_MATCH_PAIR,
  SELECT_SEARCH,
  CREATE_DEMAND,
} from '../constants/apiConstant';
import { isEmpty, isArray, isNumeric } from 'util/utils';
import { LISTINGPAGES } from '../components/DiamondList/DiamondListFunctions';
import { split } from 'lodash';
import { store } from '../appRedux/store/index';

export const SEARCH_PAGES = {
  SEARCH: '/diamond-search',
  MATCH_PAIR: '/search-match-pair',
  BIT_IT: '/search-bid-diamond',
};

export const handleSearch = async (filter, newArr, cb) => {
  let path = `${split(window.location.pathname, '/')[1]}`;
  let apiObj = {
    ...filter,
    //wSts: ['A', 'B', 'H'],
    labGrown: store.getState().commonData.labGrown,
  };
  if (LISTINGPAGES.SEARCH_DIAMOND === path) {
    const getNextBidStatus = JSON.parse(localStorage.getItem('getNextBidStatus'));
    apiObj = {
      ...apiObj,
      wSts: getNextBidStatus,
    };
  }
  _.each(apiObj, (val, key) => {
    if (isArray(val) && val.length === 0) delete apiObj[key];
    //else if (isArray(val) && isEmpty(val)) delete apiObj[key];
    else if (isArray(val)) apiObj[key] = val;
  });

  let obj = {
    filters: [apiObj],
    isNotReturnTotal: true,
    isReturnCountOnly: true,
  };

  if (newArr) obj.viewType = 2;

  let objData = {
    ...SEARCH_DIAMOND_LIST,
    request: obj,
  };

  UtilService.callApi(objData, function (err, data) {
    if (err) {
      if (err.data && err.data.message) {
        return OpenNotification({
          type: 'error',
          title: err.data.message,
        });
      }
    } else if (data && data.code === 'OK') {
      if (data.data[0].count === 0) {
        cb({ NOSTONE: 'NOSTONE', id: data.data[0].filter.id });
      } else {
        cb({ NOSTONE: '', id: data.data[0].filter.id });
      }
    }
  });
};

export const getSearchList = (cb) => {
  let obj = {
    type: 2,
    isAppendMasters: true,
    labGrown: store.getState().commonData.labGrown,
  };
  let api = SEARCH_LIST.url;
  let objData = {
    method: SEARCH_LIST.method,
    url: api,
    request: obj,
  };
  UtilService.callApi(objData, function (err, data) {
    if (err) throw err;
    if (data && data.code === 'OK') {
      cb(data.data.list);
    }
  });
};

export const handleSavedSearch = (_filter, name, id, cb) => {
  const filter = _filter;
  _.each(filter, (val, key) => {
    if (isArray(val) && val.length === 0) delete filter[key];
    else if (isEmpty(val)) delete filter[key];
    else if (isArray(val)) filter[key] = _.uniq(val);
  });

  if (_.trim(name) === '') {
    return OpenNotification({
      type: 'error',
      title: 'Please enter search title.',
    });
  }

  const request = {
    filter: filter,
    searchType: 2,
    sort: [{ createdAt: 'DESC' }],
    name,
    id,
  };

  UtilService.callApi({ ...CREATE_SAVED_SEARCH, request }, (err, res) => {
    if (err || res?.code !== 'OK') {
      OpenNotification({ type: 'error', title: err?.data?.message ?? 'Something went wrong.' });
    }

    cb(res?.data?.id ?? res?.data?.[0]?.id);
  });
};

export const handleMatchPair = (filter, cb) => {
  let apiObj = filter;
  _.each(apiObj, (val, key) => {
    if (isArray(val) && val.length === 0) delete apiObj[key];
    else if (isEmpty(val)) delete apiObj[key];
    else if (isArray(val)) apiObj[key] = val;
  });
  let obj = {
    filter: apiObj,
    page: 1,
    limit: 1000,
  };
  let api = CREATE_MATCH_PAIR.url;
  let objData = {
    method: CREATE_MATCH_PAIR.method,
    url: api,
    showLoader: true,
    request: obj,
  };

  UtilService.callApi(objData, function (err, data) {
    if (err && err.data && err.data.message) {
      return OpenNotification({
        type: 'error',
        title: err.data.message,
      });
    } else if (data && data.code === 'OK') {
      cb(data.data.filter.id);
    }
  });
};

export const handleSelectSearch = (searchId, cb) => {
  let obj = {
    id: searchId,
    isAppendMasters: true,
    labGrown: store.getState().commonData.labGrown,
  };
  let api = SELECT_SEARCH.url;
  let objData = {
    method: SELECT_SEARCH.method,
    url: api,
    request: obj,
  };
  UtilService.callApi(objData, function (err, data) {
    if (err) throw err;
    if (data && data.code === 'OK') {
      cb(data.data.list[0].searchData, data.data.list[0].name, data.data.list[0].type);
    }
  });
};

export const getCount = (filter, cb) => {
  let obj = {
    ...filter,
  };
  const filterList = {
    ...filter,
    wSts: undefined,
  };
  const filterData = filter.wSts?.includes?.('B') ? filterList : obj;
  const request = {
    isNotReturnTotal: true,
    isReturnCountOnly: true,
    isSkipSave: true,
    filters: [{
      ...filterData,
      labGrown: store.getState().commonData.labGrown,
    }],
    viewType: filter.wSts?.includes?.('B') ? 2 : undefined,
  };
  UtilService.callApi({ ...SEARCH_DIAMOND_LIST, request }, (err, res) => {
    return cb(!err && isNumeric(res?.data?.[0]?.count) ? Number(res.data[0].count) : 0);
  });
};
export const getNewArr = (filter, cb) => {
  const request = {
    ...SEARCH_DIAMOND_LIST,
    config: { loader: false },
    request: {
      isNotReturnTotal: true, isReturnCountOnly: true, isSkipSave: true, filters: [{
        ...filter,
        labGrown: store.getState().commonData.labGrown,
      }], viewType: 2
    },
  };
  UtilService.callApi(request, (err, res) => {
    void cb(res?.data?.[0]?.count);
  });
};

export const handleAddDemand = (filter, title, date, cb) => {
  let apiObj = filter;
  _.each(apiObj, (val, key) => {
    if (isArray(val) && val.length === 0) delete apiObj[key];
    else if (isEmpty(val)) delete apiObj[key];
    else if (isArray(val)) apiObj[key] = _.uniq(val);
  });

  if (_.trim(title) === '') {
    return OpenNotification({
      type: 'error',
      title: 'Please enter demand title.',
    });
  }

  if (!date) {
    return OpenNotification({
      type: 'error',
      title: 'Please select date for adding demand.',
    });
  }

  let obj = {
    filter: apiObj,
    name: title,
    searchType: 3,
    expiryDate: date,
  };

  let api = CREATE_DEMAND.url;
  let objData = {
    method: CREATE_DEMAND.method,
    url: api,
    request: obj,
  };

  UtilService.callApi(objData, function (err, data) {
    if (err) {
      OpenNotification({
        type: 'error',
        title: err.data.message || 'Something went wrong.',
      });
    } else if (data && data.code === 'OK') {
      cb(true);
      OpenNotification({
        type: 'success',
        title: 'Your demand is added successfully.',
      });
    }
  });
};
